(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__olzCsw) return; window.__olzCsw = true;
    function apply(btn) {
      var card = btn.closest('product-card') || btn.closest('.product-card');
      if (!card) return;
      var img = card.querySelector('slideshow-slide:not([hidden]) img, .card-gallery img');
      if (img) { img.removeAttribute('loading'); img.srcset = btn.dataset.srcset; img.src = btn.dataset.src; }
      card.querySelectorAll('.olz-csw__btn.is-on').forEach(function (b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = btn.dataset.url; });
    }
    var fine = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (fine) document.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('.olz-csw__btn'); if (b) apply(b);
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.olz-csw__btn'); if (!b) return;
      e.preventDefault(); e.stopPropagation(); apply(b);
      if (window.clarity) try { window.clarity('event', 'tarjeta_color'); } catch (x) {}
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
